export interface IUserActionLogger {
    registerWindow(w: Window): void;
    logEvent(e: Event): Promise<void>;
}
export class IUserActionLogger {
    private static _properties: (keyof (IUserActionLogger))[] = [];
    private static _methods: (keyof (IUserActionLogger))[] = ["registerWindow", "logEvent"];

    public static [Symbol.hasInstance](instance: any): boolean {
        return instance != null && !this._properties.some((value) => !Reflect.has(instance, value)) &&
            !this._methods.some(value => typeof instance[value] !== "function");
    }
}
